if (typeof Array.createRange !== 'function') {
  Array.prototype.createRange = function (start, stop) {
    for (let idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
      this.push(String.fromCharCode(idx));
    }

    return this;
  };
}

if (typeof Array.toggle !== 'function') {
  Array.prototype.toggle = function (value) {
    const index = this.indexOf(value);

    if (index === -1) {
      this.push(value);
    } else {
      this.splice(index, 1);
    }

    return this;
  };
}